/** Cookie с yclid (ставится из inline-скрипта в index.html с URL Директа). */
export const SITE_YCLID_COOKIE_NAME = "virtuoz_yclid";
/** Cookie Яндекс.Метрики с ClientID того же браузера (ставит сам tag.js). */
export const YM_UID_COOKIE_NAME = "_ym_uid";
/** Числовой ClientID для Measurement Protocol (тот же браузер), не UUID. */
export const SITE_METRIKA_CLIENT_ID_KEY = "virtuoz_site_metrika_client_id";
/** Одна отправка «start» за сессию вкладки. */
export const SITE_ANALYTICS_START_SESSION_KEY = "virtuoz_site_analytics_start_sent";
/** ClientID для mc.yandex.ru/collect — только цифры (как у ym getClientID). */
export const METRIKA_NUMERIC_CID_RE = /^\d{10,24}$/;
export function isValidMetrikaNumericCid(value) {
    return Boolean(value && METRIKA_NUMERIC_CID_RE.test(value));
}
const YCLID_RE = /^[a-zA-Z0-9._-]{1,128}$/;
/**
 * yclid с текущего URL или cookie (tag.js не нужен).
 */
export function readVirtuozYclid() {
    if (typeof window === "undefined") {
        return undefined;
    }
    try {
        const m = window.location.search.match(/[?&]yclid=([^&]*)/);
        if (m) {
            const v = decodeURIComponent(m[1].replace(/\+/g, " ")).trim();
            if (v && YCLID_RE.test(v)) {
                return v;
            }
        }
    }
    catch {
        /* ignore */
    }
    try {
        const parts = document.cookie.split(";");
        for (const part of parts) {
            const idx = part.indexOf("=");
            if (idx === -1) {
                continue;
            }
            const name = part.slice(0, idx).trim();
            if (name !== SITE_YCLID_COOKIE_NAME) {
                continue;
            }
            const v = decodeURIComponent(part.slice(idx + 1).trim());
            if (v && YCLID_RE.test(v)) {
                return v;
            }
        }
    }
    catch {
        /* ignore */
    }
    return undefined;
}
/**
 * Ранее сохранённый ClientID (ycid) из ym getClientID или ранее
 * сгенерированный синтетический. Если ничего нет — null.
 */
export function readPersistedSiteMetrikaClientId() {
    if (typeof window === "undefined" || typeof localStorage === "undefined") {
        return null;
    }
    try {
        const existing = localStorage.getItem(SITE_METRIKA_CLIENT_ID_KEY);
        if (existing && isValidMetrikaNumericCid(existing)) {
            return existing;
        }
    }
    catch {
        /* ignore */
    }
    return null;
}
/**
 * ClientID из cookie `_ym_uid` (его ставит сам tag.js Метрики). Полезно, когда
 * на текущей загрузке счётчик не поднялся (заблокирован/оффлайн), но Метрика
 * уже работала на прошлых заходах — значение совпадает с ym getClientID.
 */
export function readYmUidCookie() {
    if (typeof document === "undefined") {
        return null;
    }
    try {
        const parts = document.cookie.split(";");
        for (const part of parts) {
            const idx = part.indexOf("=");
            if (idx === -1) {
                continue;
            }
            const name = part.slice(0, idx).trim();
            if (name !== YM_UID_COOKIE_NAME) {
                continue;
            }
            const v = decodeURIComponent(part.slice(idx + 1).trim());
            if (isValidMetrikaNumericCid(v)) {
                return v;
            }
        }
    }
    catch {
        /* ignore */
    }
    return null;
}
/** 10 случайных десятичных цифр (crypto, если доступен — иначе Math.random). */
function randomDigits(count) {
    let out = "";
    try {
        const c = typeof crypto !== "undefined" ? crypto : undefined;
        if (c && typeof c.getRandomValues === "function") {
            const arr = new Uint8Array(count);
            c.getRandomValues(arr);
            for (let i = 0; i < count; i++) {
                out += String(arr[i] % 10);
            }
            return out;
        }
    }
    catch {
        /* ignore — упадём в Math.random ниже */
    }
    for (let i = 0; i < count; i++) {
        out += String(Math.floor(Math.random() * 10));
    }
    return out;
}
/**
 * Синтетический ClientID по правилу: 20 цифр, где первые 10 — Unix-таймстамп
 * (секунды) первого захода пользователя, остальные 10 — случайные. Значение
 * persist-ится, поэтому «первый заход» фиксируется единожды и не меняется.
 */
export function generateSiteMetrikaClientId() {
    const tsSeconds = Math.floor(Date.now() / 1000);
    const ts10 = String(tsSeconds).slice(0, 10).padStart(10, "0");
    return `${ts10}${randomDigits(10)}`;
}
/**
 * Стабильный ClientID для текущего браузера: сохранённый ранее или новый
 * синтетический ({@link generateSiteMetrikaClientId}), который сразу же
 * persist-ится в localStorage.
 */
export function getOrCreateSiteMetrikaClientId() {
    const persisted = readPersistedSiteMetrikaClientId();
    if (persisted) {
        return persisted;
    }
    const id = generateSiteMetrikaClientId();
    if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
        try {
            localStorage.setItem(SITE_METRIKA_CLIENT_ID_KEY, id);
        }
        catch {
            /* ignore */
        }
    }
    return id;
}
